import React from 'react';
import { motion } from 'framer-motion';
const galleryImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/wTdvc4KpbdXGz6jRWRx6WM/WhatsApp_Image_2026-03-31_at_11.50.20_PM_(1).jpg',
  alt: 'Kia PV5 front three-quarter view with multiple vehicles in showroom',
  className: 'col-span-2 row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jzK3zvzN6z8D86ZQGkpJcc/WhatsApp_Image_2026-03-31_at_11.50.21_PM.jpg',
  alt: 'Kia PV5 side view with sliding door open showing cargo area and Kia PBV sign',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aBARzCxEappLHPGVTTKrxc/WhatsApp_Image_2026-03-31_at_11.50.20_PM.jpg',
  alt: 'Kia PV5 rear three-quarter view showing Kia badge and tail lights in showroom',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bskmGSQrpxfrBr2vsEATY2/WhatsApp_Image_2026-03-31_at_11.50.19_PM_(5).jpg',
  alt: 'Kia PV5 dramatic front three-quarter angle in showroom with Kia PBV branding',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1gGJafXxBDAdHHMwYes2up/WhatsApp_Image_2026-03-31_at_11.50.19_PM_(2).jpg',
  alt: 'Kia PV5 clean side profile in showroom with glass windows behind',
  className: 'col-span-1 row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/s9K5kghUAMzwgx2mTbtRoH/WhatsApp_Image_2026-03-31_at_11.50.19_PM_(3).jpg',
  alt: 'Kia PV5 rear three-quarter view by showroom window with natural light',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/f86YKg9CJK3uWCqk3tk2nq/WhatsApp_Image_2026-03-31_at_11.50.19_PM_(1).jpg',
  alt: 'Kia PV5 front view with two PV5 vehicles behind in showroom',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aywCq7boTsoBmWLPMVcfTn/WhatsApp_Image_2026-03-31_at_11.50.19_PM.jpg',
  alt: 'Kia PV5 head-on front view showing bold Kia face design in showroom',
  className: 'col-span-2 row-span-1'
}];
export function GallerySection() {
  return <section className="relative w-full bg-dark-800 py-24 md:py-32" data-id="element-65">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-67">
          <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 font-body" data-id="element-68">
            Gallery
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-69">
            The PV5 <span className="text-gold italic" data-id="element-70">Up Close</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[240px] gap-3 md:gap-4" data-id="element-71">
          {galleryImages.map((image, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.07
        }} className={`relative rounded-xl overflow-hidden border border-white/5 group cursor-pointer ${image.className}`} data-id="element-72">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out" data-id="element-73" />
              <div className="absolute inset-0 bg-dark-900/0 group-hover:bg-dark-900/20 transition-colors duration-500" data-id="element-74" />
              <div className="absolute inset-0 border border-gold/0 group-hover:border-gold/20 rounded-xl transition-colors duration-500" data-id="element-75" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}